import instance from "./Instance/index.js";

export const getCurriculums = async () => {
  try {
    const response = await instance.get(`/curriculums`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getCurriculum = async (id) => {
  try {
    const response = await instance.get(`/curriculums/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getUserCurriculums = async (id) => {
  try {
    const response = await instance.get(`/curriculums/view/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getTopCurriculums = async () => {
  try {
    const response = await instance.get(`/curriculums/public/top`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getCurriculumforUsers = async () => {
  try {
    const response = await instance.get(`/curriculums/public/users`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getPublicCurriculums = async () => {
  try {
    const response = await instance.get(`/curriculums/admin/public`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getPrivateCurriculums = async () => {
  try {
    const response = await instance.get(`/curriculums/admin/private`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getUserPublicCurriculums = async (values) => {
  try {
    const response = await instance.post(`/curriculums/user/public`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getUserPrivateCurriculums = async (values) => {
  try {
    const response = await instance.post(`/curriculums/user/private`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const createCurriculums = async (values) => {
  try {
    const response = await instance.post(`/curriculums/create`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const updateCurriculum = async (id, values) => {
  try {
    const response = await instance.put(`/curriculums/update/${id}`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const publishCurriculum = async (id) => {
  try {
    const response = await instance.put(`/curriculums/publish/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const deleteCurriculum = async (id) => {
  try {
    const response = await instance.delete(`/curriculums/delete/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};
